module.exports = __webpack_public_path__ + "img/norsepower-logo.46a411ef.png";